// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"ded1d20e","345":"ded1d20e","396":"ded1d20e","614":"ded1d20e","651":"ded1d20e","984":"ded1d20e"}[chunkId] + ".chunk.css";
};